import { render } from "./ProductListTableHeader.vue?vue&type=template&id=af37a492"
import script from "./ProductListTableHeader.vue?vue&type=script&lang=js"
export * from "./ProductListTableHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__